var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.92744 6.14756L12.5724 14.7963C14.4579 16.6782 17.5401 16.6798 19.4271 14.7963L28.0721 6.14756C28.1592 6.0605 28.1465 5.91713 28.0455 5.84669C27.1637 5.23175 26.0909 4.86719 24.9353 4.86719H7.06431C5.90863 4.86719 4.83581 5.23181 3.95406 5.84669C3.85306 5.91713 3.84037 6.0605 3.92744 6.14756ZM1.61719 10.3143C1.61719 9.4055 1.8425 8.54688 2.23937 7.79219C2.30144 7.67413 2.45875 7.65025 2.55306 7.74456L11.0886 16.2801C13.7916 18.987 18.2064 18.9886 20.911 16.2801L29.4466 7.74456C29.5409 7.65025 29.6982 7.67413 29.7603 7.79219C30.1571 8.54688 30.3824 9.40556 30.3824 10.3143V21.6853C30.3824 24.6911 27.9374 27.1324 24.9353 27.1324H7.06431C4.06231 27.1324 1.61719 24.6911 1.61719 21.6853V10.3143Z",
    fill: "#FF5861"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMail);
export default __webpack_public_path__ + "static/media/icon_mail.cf069c1e944083eda5c3f0939bb3c964.svg";
export { ForwardRef as ReactComponent };